import React from 'react'
import Layout from '../../Layout/Layout'
import innovation1 from '../../images/innovation1.PNG'

import innovation2 from '../../images/innovation2.PNG'

import { Link } from "react-router-dom";

const Innovation_Fair = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Innovation Fair</h2></div>


            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>In alignment with the Africa–Europe Innovation Agenda, 
                        Moolu Venture Lab's participation in the AU–EU Innovation Fair 2025 in
                         Brussels marked a key engagement in the global research and innovation 
                         community. This event provided a crucial platform for Moolu Venture Lab
                          to showcase its comprehensive work in cross-continental innovation at
                           the high-profile Africa–Europe Innovation Platform (AIEP) session. 
                           The Lab's presence affirmed its significant role as a continental
                            connector—actively linking African innovation pipelines to global
                             opportunity networks. 
</p>

                <p className='light'>
During the Fair, Moolu Venture Lab engaged extensively with over 500 participants,
 including a diverse audience of startups, international investors, policymakers,
  and research and innovation agencies. A primary focus of the engagement was the
   successful demonstration of the value derived from research-driven innovation,
    effective commercialization models, and its strategic approach to cross-border
     acceleration. This networking effort was instrumental in strengthening existing
      partnerships with key African Union (AU), European Union (EU), and Mediterranean
       innovation institutions.
</p>
               </div>

                <div className='uk-width-1-2@s'>

                    <img src={innovation1} />
                              </div>
            </div>




            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>

                <img src={innovation2} />
                
               </div>

                <div className='uk-width-1-2@s'>
                                 <p className='light'>
                                    Ultimately, the Lab's involvement served as a powerful 
                                    advocacy platform for the establishment of more inclusive 
                                    and sustainable research-to-market pathways across the entire 
                                    African continent. By showcasing its expertise and successful
                                     models, Moolu Venture Lab demonstrated its capacity to attract
                                      global funding and resources into the African innovation 
                                      ecosystem. The presence successfully solidified its reputation
                                       as a leading organization that bridges the geographical gap
                                        to unlock global growth opportunities for African ventures.
                   </p>

             
                    
                              </div>
            </div>





        </div>
        </Layout>
  )
}

export default Innovation_Fair